import React, { useCallback } from 'react';
import Input from './Input';

const NumberInput = ({
  isInteger = false,
  charactersAfterComma,
  ...props
}: {
  isInteger?: boolean;
  charactersAfterComma?: number;
  [key: string]: any;
}) => {
  const handleChange = useCallback(
    (value: string) => {
      if (isInteger) {
        return value.replace(/[^\d]/g, '');
      }

      let cleanValue = value.replace(/[^\d.]/g, '').replace(/\.(?=.*\.)/g, '');

      if (charactersAfterComma !== undefined && cleanValue.includes('.')) {
        const [integerPart, decimalPart] = cleanValue.split('.');
        const limitedDecimal = decimalPart ? decimalPart.slice(0, charactersAfterComma) : '';
        return `${integerPart}.${limitedDecimal}`;
      }

      return cleanValue;
    },
    [isInteger, charactersAfterComma]
  );

  return <Input {...props} changeProxy={handleChange} />;
};

export default NumberInput;
